export const variables = {
  
  API_URL: "https://eng-roster-backend-azapp-72.azurewebsites.net/api/",
   
}